<template>
    <div class="new-dual-wrapper" :data-aos="aos" :data-aos-delay="delay">
        <div class="new-dual-left" :style="{ backgroundColor: leftBg }">
            <div class="new-dual-title">{{ left.title }}</div>
            <div class="new-dual-desc">{{ left.description }}</div>
            <div class="new-btn-group">
                <router-link :to="left.link" class="new-btn-primary">Learn More</router-link>
            </div>
            <div class="new-dual-img">
                <img :src="left.image" :alt="left.title" />
            </div>
        </div>
        <div class="new-dual-right" :style="{ backgroundColor: rightBg }">
            <div class="new-dual-title">{{ right.title }}</div>
            <div class="new-dual-desc">{{ right.description }}</div>
            <div class="new-btn-group">
                <router-link :to="right.link" class="new-btn-primary">Learn More</router-link>
            </div>
            <div class="new-dual-img">
                <img :src="right.image" :alt="right.title" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DualWrapper',
    props: {
        left: Object,   // { title, description, link, image }
        right: Object,
        leftBg: { type: String, default: '#f5f5f7' },
        rightBg: { type: String, default: '#ffffff' },
        aos: { type: String, default: 'fade-up' },
        delay: { type: Number, default: 0 },
    },
};
</script>

<style scoped>
.new-dual-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
    margin: 40px 0;
}

.new-dual-left,
.new-dual-right {
    flex: 1;
    border-radius: 40px;
    padding: 60px 40px;
    text-align: center;
    transition: transform 0.3s;
}

.new-dual-left:hover,
.new-dual-right:hover {
    transform: translateY(-8px);
}

.new-dual-title {
    font-size: 2.5rem;
    font-weight: 600;
    margin-bottom: 16px;
}

.new-dual-desc {
    font-size: 1.1rem;
    color: #6c757d;
    margin-bottom: 24px;
}

.new-btn-primary {
    display: inline-block;
    background-color: #0071e3;
    color: white;
    padding: 12px 28px;
    border-radius: 40px;
    text-decoration: none;
    font-weight: 500;
    transition: background 0.2s;
}

.new-btn-primary:hover {
    background-color: #005bb5;
}

.new-dual-img {
    display: flex;
    justify-content: center;
}

.new-dual-img img {
    max-width: 60%;
    margin-top: 40px;
}

@media (max-width: 768px) {
    .new-dual-wrapper {
        flex-direction: column;
    }

    .new-dual-title {
        font-size: 1.8rem;
    }
}
</style>